export { default as MaterialsIndexPageCategoriesNavHead } from './MaterialsIndexPageCategoriesNavHead';
